var a = ".gator-skip-link-list-item{padding:var(--spacing-gap-8, 8px) var(--spacing-gap-16, 16px)}";
export { a as default };